import type { ResearchIconName } from "@/lib/icons/research-icons";

export const DEFAULT_ROW_GRID = {
  sectionId: "grid",
  title: "",
  subtitle: "",
  backgroundImageUrl: "",
  rows: [
    {
      columns: 3,
      gap: "medium",
      cards: [
        {
          icon: "clock" as ResearchIconName,
          title: "5–10 минут",
          text: "Время генерации полного отчёта.",
          imageUrl: "",
        },
        {
          icon: "fileText" as ResearchIconName,
          title: "11+ страниц",
          text: "Структурированный desk research с выводами.",
          imageUrl: "",
        },
        {
          icon: "radar" as ResearchIconName,
          title: "6 критериев",
          text: "Scoring и итоговая оценка ниши.",
          imageUrl: "",
        },
      ],
    },
    {
      columns: 2,
      gap: "medium",
      cards: [
        {
          icon: "barChart" as ResearchIconName,
          title: "Рынок РФ",
          text: "TAM, конкуренты и бенчмарки — с источниками.",
          imageUrl: "",
        },
        {
          icon: "gitCompare" as ResearchIconName,
          title: "Go / no-go",
          text: "Рекомендация и план следующих шагов.",
          imageUrl: "",
        },
      ],
    },
  ],
};
